function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon/editor/ic-attach-file");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M16,6 L16,17.5 C16,19.71 14.21,21.5 12,21.5 C9.79,21.5 8,19.71 8,17.5 L8,5 C8,3.62 9.12,2.5 10.5,2.5 C11.88,2.5 13,3.62 13,5 L13,15.5 C13,16.05 12.55,16.5 12,16.5 C11.45,16.5 11,16.05 11,15.5 L11,6 L9.5,6 L9.5,15.5 C9.5,16.88 10.62,18 12,18 C13.38,18 14.5,16.88 14.5,15.5 L14.5,5 C14.5,2.79 12.71,1 10.5,1 C8.29,1 6.5,2.79 6.5,5 L6.5,17.5 C6.5,20.54 8.96,23 12,23 C15.04,23 17.5,20.54 17.5,17.5 L17.5,6 L16,6 Z",
  id: "path-1"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "icon/editor/ic-attach-file",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "icon/editor/attach_file_24px",
  fill: "#333340",
  xlinkHref: "#path-1"
}));

var SvgIcAttachFile = function SvgIcAttachFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcAttachFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-attach-file.509b396c.svg";
export { ForwardRef as ReactComponent };